import {
  useIsMenuOpen,
  useToggleMenu,
  useIsDarkSlide,
  useIsInHeroSection,
} from "@/stores/uiStore";

export default function MenuButton() {
  const isMenuOpen = useIsMenuOpen();
  const toggleMenu = useToggleMenu();
  const isDarkSlide = useIsDarkSlide();
  const isInHeroSection = useIsInHeroSection();

  const barColor = isMenuOpen
    ? "bg-white"
    : !isInHeroSection || !isDarkSlide
      ? "bg-white"
      : "bg-zinc-900";

  return (
    <button
      onClick={toggleMenu}
      className="relative z-50 w-10 h-10 flex flex-col items-center justify-center gap-1.5 group"
      aria-label={isMenuOpen ? "Close menu" : "Open menu"}
      aria-expanded={isMenuOpen}
    >
      <span
        className={`block w-6 h-0.5 transition-all duration-300 ease-smooth origin-center ${barColor} ${
          isMenuOpen ? "rotate-45 translate-y-[4px]" : ""
        }`}
      />
      <span
        className={`block w-6 h-0.5 transition-all duration-300 ease-smooth origin-center ${barColor} ${
          isMenuOpen ? "-rotate-45 -translate-y-[4px]" : ""
        }`}
      />
    </button>
  );
}
